/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, Toggle } from '@one-thd/sui-atomic-components';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { NearbyStores } from '../../StoreSelector/NearbyStores';

export const InNearbyStoreDesktop = ({
  isNearbyStores,
  onNearbyStoresToggle,
  toggleChangeStore,
  storeSearch,
  multiStoreSelection,
  onMultiStoreSelectionChange,
  setIsNearbyStores
}) => {
  const storeSelectorClassName = 'sui-w-max sui-mt-1';
  const contentClasses = 'store-selector__content';

  return (
    <div className="sui-flex sui-mt-3" data-testid="in-nearby-store-desktop">
      <Toggle
        inputAttributes={{ 'aria-label': 'In Store' }}
        checked={isNearbyStores}
        onChange={onNearbyStoresToggle}
      />
      <div className={storeSelectorClassName}>
        {
          isNearbyStores && (
            <Tooltip
              channel="desktop"
              closeButton
              placement="right"
              portal
              content={(
                <div className={contentClasses}>
                  <NearbyStores
                    stores={storeSearch}
                    multiStoreCallback={onMultiStoreSelectionChange}
                    multiStoreSelection={multiStoreSelection}
                    setNearbyStores={setIsNearbyStores}
                  />
                </div>
              )}
            >
              <div
                className="sui-font-regular sui-text-base sui-flex sui-leading-tight sui-items-center"
              >
                <span className="sui-px-1">Include</span>
                <button
                  className="sui-pr-1 sui-flex sui-items-center sui-gap-1"
                  type="button"
                  aria-label="store selector caret"
                  tabIndex="0"
                  onClick={toggleChangeStore}
                >
                  <Link underline="always">
                    nearby stores
                  </Link>
                </button>
              </div>
            </Tooltip>
          )
        }
        {!isNearbyStores && (
          <div
            className="sui-font-regular sui-text-base sui-flex sui-leading-tight sui-items-center"
          >
            <span className="sui-px-1">Include nearby stores</span>
          </div>
        )}
      </div>
    </div>
  );

};

InNearbyStoreDesktop.propTypes = {
  isNearbyStores: PropTypes.bool.isRequired,
  onNearbyStoresToggle: PropTypes.func.isRequired,
  toggleChangeStore: PropTypes.func.isRequired,
  storeSearch: PropTypes.arrayOf(PropTypes.shape({
    storeId: PropTypes.string,
    storeName: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.shape({
      postalCode: PropTypes.string
    })
  })),
  multiStoreSelection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onMultiStoreSelectionChange: PropTypes.func,
  setIsNearbyStores: PropTypes.func.isRequired
};

InNearbyStoreDesktop.defaultProps = {
  storeSearch: [],
  multiStoreSelection: [],
  onMultiStoreSelectionChange: () => {}
};
